import React from 'react';

import Quotation from '../components/quotation';

const QuotationPage = ({ match }) => {
    return (
      <Quotation quotationId={match.params.quotationId}/>
    )
}

export default QuotationPage;


// WEBPACK FOOTER //
// ./src/containers/quotation-page.js